import Vue from 'vue'
import ScrollEvents from 'scroll-events'

Vue.directive('viewport', {
  bind (el, {name}, vnode) {
    const $store = vnode.context.$store
    const self = Vue.directive(name)
    if (!$store) throw new Error('This plugin requires a Vuex store')
    if (!self) throw new Error('Directive is not defined')

    $store.dispatch('viewport/setDevice', self.getDevice())

    $store.dispatch('viewport/setWindowSize', self.getWindowSize()).then((d) => {})

    window.addEventListener('resize', function () {
      $store.dispatch('viewport/setWindowSize', self.getWindowSize()).then(() => {})
    })

    const scrollEvents = new ScrollEvents()

    const u = (status) => {
      $store.dispatch('viewport/setWindowProgress', {
        status,
        progress: scrollEvents.y,
        direction: scrollEvents.directionY,
        speed: scrollEvents.speedY
      }).then(() => {})
    }

    scrollEvents.on('scroll:start', () => u('start'))
    scrollEvents.on('scroll:progress', () => u('progress'))
    scrollEvents.on('scroll:stop', () => u('stop'))
  },
  unbind () {
    window.removeEventListener('resize', function () {}, true)
    window.removeEventListener('scroll', function () {}, true)
  },
  getWindowSize () {
    const bd = document.body
    const hm = document.documentElement

    const wd = window.innerWidth || document.documentElement.clientWidth || bd.clientWidth
    const ht = window.innerHeight || document.documentElement.clientHeight || bd.clientHeight
    const sh = Math.max(bd.scrollHeight, bd.offsetHeight, hm.clientHeight, hm.scrollHeight, hm.offsetHeight)

    return {
      width: wd,
      height: ht,
      scrollheight: sh
    }
  },
  getDevice () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // Windows Phone must come first because its UA also contains 'Android'
    let agent = (/windows phone/i.test(userAgent)) ? 'Windows Phone'
                : (/android/i.test(userAgent)) ? 'Android'
                : (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ? 'iOS'
                : undefined
    return agent
  }
})



// WEBPACK FOOTER //
// ./assets/js/directives/viewport.js